<template>
  <div class="wrapper">
    <side-bar type="sidebar" :sidebar-links="$sidebar.sidebarLinks">
      <user-menu></user-menu>
    </side-bar>
    <!--Sending state-->
    <loading :active.sync="this.$store.getters.getLogoutState"
    :can-cancel="false" 
    :is-full-page="true">
    </loading>
    <!--./Sending state-->
    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar">
      </dashboard-content>
      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import Vue from 'vue';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'
  import store from '../../../store/store'
  import { crono } from 'vue-crono'
  import SecureLS from 'secure-ls';
  import moment from 'moment';
  import { mapGetters, mapState } from 'vuex';
  import IdleJs from 'idle-js'
  import { REFRESH_TOKEN } from 'src/api/graphql/mutations/auth/RefreshToken';
  import { REVOKE_TOKEN } from 'src/api/graphql/mutations/auth/RevokeToken';
  import { VERIFY_TOKEN } from 'src/api/graphql/mutations/auth/VerifyToken';
  export default {
    mixins: [crono],
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
      Loading
    },
    data() {
      return{
        permissions_array: []
      }
    },
    methods: {
      permissionReview(permission){
        /***
        * Función para validar que una funcionalidad está permitida para un usuario
        */
      },
      beforeUnloadLogout(){
        /***
        * Función para controlar que un usuario al cerrar la ventana del navegador, la sesión sea cerrada
        */
        window.addEventListener('beforeunload', () => {
            var vm = this;
            var deleteAccessToken = new SecureLS({encodingType: 'aes'});
            var flag = deleteAccessToken.remove('adminAccessToken');
            var deleteLoggingIn = new SecureLS({encodingType: 'aes'});
            var loginFlag = deleteLoggingIn.remove('adminLoggingIn');
            var adminRefreshTokenDecoded = new SecureLS({encodingType: 'aes'});
            var myToken = adminRefreshTokenDecoded.get('adminRefreshToken').data;
            this.$apollo.mutate({
              mutation: REVOKE_TOKEN,
              variables : {
                  input : {
                    refreshToken: myToken,
                  }
                }
            }).then((data) => {
              this.$store.dispatch('logout').then(()=>{
                router.go('/login');
              });
            }).catch((error) => {
              
            });
        }, false)
      },
      idleCreate(){
        /***
        * Función necesaria para controlar el tiempo de inactividad del usuario
        */
        var vm = this;
        var idle = new IdleJs({
          idle: this.$store.getters.getIdleTime, // idle time in ms
          events: ['mousemove', 'keydown', 'mousedown', 'touchstart'], // events that will trigger the idle resetter
          onIdle: function () {
            vm.onIdle();
          },
        });
        idle.start();
      },
      onIdle() {
        /***
        * Función necesaria para cerrar sesión en caso de detectar el tiempo de inactividad programado
        */
        var vm = this;
        var adminRefreshTokenDecoded = new SecureLS({encodingType: 'aes'});
        var myToken = adminRefreshTokenDecoded.get('adminRefreshToken').data;
        this.$apollo.mutate({
          mutation: REVOKE_TOKEN,
          variables : {
              input : {
                refreshToken: myToken,
              }
            }
        }).then((data) => {
          this.$store.dispatch('logout').then(()=>{
            router.go('/login');
          });
        }).catch((error) => {
          
        });
      },
      verify(){
        /**
         * Función para refrescar el token 30 segundos antes de su vencimiento
         */
        var adminTokenExpireDate = new SecureLS({encodingType: 'aes'});
        var secondsDiff = moment().diff(moment.unix(adminTokenExpireDate.get('adminTokenExpireDate').data), 'seconds');
        if(secondsDiff >= -30){
          // Iniciamos el envío de la mutación
          var vm = this;
          var adminRefreshTokenDecoded = new SecureLS({encodingType: 'aes'});
          var myToken = adminRefreshTokenDecoded.get('adminRefreshToken').data;
          this.$apollo.mutate({
            mutation: REFRESH_TOKEN,
            variables : {
                input : {
                  refreshToken: myToken,
                }
              }
          }).then((data) => {
            this.$store.dispatch('updateToken',data.data.refreshToken);
          }).catch((error) => {
            
          });
        }
        else{
          var vm = this;
          var adminAccessTokenDecoded = new SecureLS({encodingType: 'aes'});
          var myToken = adminAccessTokenDecoded.get('adminAccessToken').data;
          this.$apollo.mutate({
            mutation: VERIFY_TOKEN,
            variables : {
                input : {
                  token: myToken,
                }
              }
          }).then((data) => {
            // console.log(data)
          }).catch((error) => {
            
          });
        }
      },
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    },

    cron:{
      time: 10000,
      method: 'verify'
    },
    computed: {},
    created(){
      this.idleCreate();
      this.beforeUnloadLogout();
    },
    beforeCreate(){
    },
    beforeDestroy(){
    },
    mounted(){
      var permissions = new SecureLS({encodingType: 'aes'});
      this.permissions_array = permissions.get('permissions').data;
    }
  }

</script>
